import { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../creds";
import TranslationDiffSegmentViewer from "../../utils/TranslationDiffViewer";

export default function TranslationDiffModal({
  taskId,
  isOpen,
  onClose,
  rtlTarget,
}) {
  const [machineText, setMachineText] = useState("");
  const [editedText, setEditedText] = useState("");
  // const [wordEditResult, setWordEditResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");


  useEffect(() => {
    if (!isOpen || !taskId) return;
    
    const fetchRawTexts = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await axios.post(`${API_URL}/translation-diff`,  { taskid: taskId },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              "Content-Type": "application/json",
            },
            timeout: 12000,
          }
        );

        const data = res.data;
        const machine = data.machine_raw || "";
        const edited = data.edited_raw || "";

        setMachineText(machine);
        setEditedText(edited);

      } catch (err) {
        console.error(err);
        let msg = "Failed to load diff.";
        if (err.code === "ECONNABORTED" || err.message?.includes("Network") || err.message?.includes("abort")) {
          msg = "Connection dropped (server reloaded?). Click 'Retry' or refresh page.";
        } else if (err.response) {
          msg = err.response.data?.detail || `Server error: ${err.response.status}`;
        }
        
        setError(msg);
      } finally {
        setLoading(false);
      }
    };
    fetchRawTexts();
    // eslint-disable-next-line
  }, [isOpen, taskId]);



  return (
    <TranslationDiffSegmentViewer
    taskId={taskId}
    machineText={machineText}
    editedText={editedText}
    isRtl={rtlTarget === "ur"}
    onClose={onClose}
    loading={loading}
    error={error}
  />
  );
}